import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import { ExpandableSection } from '../../components/expandableSection';
import { GameGuideHelpButton } from '../../components/gameGuideHelpButton';
import { IconWithLabelDisplay } from '../../components/iconWithLabelDisplay';
import { PLAYER_INFO_PANEL_CONTENT_HOVER_COLOR } from '../../styles/colors';
import { PanelItem } from '../panelItem';
import { PanelItemDivider } from '../panelItemDivider';
import { MedalPanelItem } from './medalPanelItem';
function getEmptyMedalsContent(username, isPowerPlayer) {
    if (isPowerPlayer) {
        return 'None';
    }
    return (_jsx(IconWithLabelDisplay, { label: username
            ? `${username} needs to be a Power Player to show their medals`
            : 'You need to be a Power Player to see your medals', isSubtle: true }));
}
function getContents(username, medals, isPowerPlayer) {
    if (!medals.length) {
        return _jsx(PanelItem, { children: getEmptyMedalsContent(username, isPowerPlayer) });
    }
    return (_jsx(_Fragment, { children: medals.map((medal, i) => (_jsxs(Fragment, { children: [i > 0 ? _jsx(PanelItemDivider, { color: PLAYER_INFO_PANEL_CONTENT_HOVER_COLOR, thicknessPx: 2 }) : null, _jsx(MedalPanelItem, { medal: medal })] }, i))) }));
}
export const MedalsSubPanelContainer = ({ medals, isPowerPlayer, username }) => {
    return (_jsx(ExpandableSection, { expandableSectionType: username ? 'player-medals' : 'self-medals', colorType: 'player-info', headerRight: _jsx(GameGuideHelpButton, { pageType: 'medals', title: 'Medals Info' }), children: getContents(username, medals, isPowerPlayer) }));
};
